/**
 * OwalFilterPredicate.js
 *
 * @description Defines a predicate which extends the base predicate,
 * adding a predefined value to filter for, and a display title.
 */

import { OwalSearchPredicate } from './OwalSearchPredicate'
import { OwalSearchMatchCondition } from './OwalSearchMatchCondition'

export class OwalFilterPredicate extends OwalSearchPredicate {
  /**
   * Creates an instance of OwalSearchTerm.
   * @param {String} displayName A name to use for the filter in user interfaces. Not localized.
   * @param {any} value The value to filter against.
   * @param {Array<String>} searchKeys The properties to search. (Passing in an empty array is undefined behavior, right now.)
   * @param {OwalSearchMatchCondition} matchCondition Specifies if the predicate requires an exact match, beginning match, etc to be true.
   * @param {Bool} caseSensitive Specifies if the search is case sensitive. false by default.
   * @memberof OwalSearchPredicate
   */
  constructor ({ displayName, value, searchKeys, matchCondition = OwalSearchMatchCondition.INCLUDES, caseSensitive = false, callback } = {}) {
    super({ searchKeys, matchCondition, caseSensitive })
    this.displayName = displayName
    this.value = value
    this.callback = callback
  }
}
